/**
 * @name NavAnchor
 * @description
 * This is a custom element that is used to navigate to a specific element on the page
 * without updating the URL and History.
 */

export class NavAnchor extends HTMLElement {
  private anchor: HTMLAnchorElement

  constructor() {
    super()
    // Create internal anchor element
    this.anchor = document.createElement('a')
    // Move all children to the anchor
    while (this.firstChild) {
      this.anchor.appendChild(this.firstChild)
    }
    // Copy attributes from custom element to anchor
    Array.from(this.attributes).forEach(attr => {
      if (attr.name !== 'is') {
        this.anchor.setAttribute(attr.name, attr.value)
      }
    })
    this.appendChild(this.anchor)
    this.anchor.addEventListener('click', this.handleClick.bind(this))
  }

  connectedCallback(): void {
    // No longer needed as we handle this in constructor
  }

  disconnectedCallback(): void {
    // Clean up event listener when element is removed
    this.anchor.removeEventListener('click', this.handleClick)
  }

  handleClick(event: MouseEvent): void {
    // Prevent default anchor behavior (URL update and history change)
    event.preventDefault()
    event.stopPropagation()
    event.stopImmediatePropagation()

    // Get the target element ID from the href attribute
    const href: string = this.anchor.getAttribute('href') || ''

    // Extract the ID from the href - remove the "#" if it exists
    const targetId: string = href.startsWith('#') ? href.substring(1) : href

    if (!targetId) return

    // Find the target element
    const targetElement: HTMLElement | null = document.getElementById(targetId)
    if (!targetElement) return

    // Scroll to the target element smoothly
    targetElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'start'
    })
  }
}
